import NoResults from '@/components/table/noResults';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { dateFormatter } from '@/shared/utils/date';
import { format } from 'date-fns';
import { activityLogTableColumns } from '../../constants';
import { AllocationOperationsWorkflowTransitionHistoryDto } from '../../types';

interface TableBodyProps {
  activityLogTableData: AllocationOperationsWorkflowTransitionHistoryDto[];
}

const TableBody = ({ activityLogTableData }: TableBodyProps) => {
  if (!activityLogTableData?.length) {
    return <NoResults />;
  }

  return (
    <>
      {activityLogTableData.map((row) => (
        <TableRowWrapper key={row.id}>
          <TableRowCell width={activityLogTableColumns[0].width}>
            <TextCell>{row?.createdAt && dateFormatter(format(new Date(row.createdAt), 'yyyy-MM-dd'), 'yyyy-MM-dd')}</TextCell>
          </TableRowCell>
          <TableRowCell width={activityLogTableColumns[1].width}>
            <TextCell>{row?.operationsWorkflowTransitionTask?.name ?? ''}</TextCell>
          </TableRowCell>
          <TableRowCell width={activityLogTableColumns[2].width}>
            <TextCell>
              {row?.user ? `${row.user.firstName} ${row.user.lastName}` : row?.platformManagerTenantName ? row.platformManagerTenantName : '--'}
            </TextCell>
          </TableRowCell>
        </TableRowWrapper>
      ))}
    </>
  );
};

export default TableBody;
